import { createSlice } from '@reduxjs/toolkit'

import { stateName } from './constants'
import { State } from './types'

export const initialState: State = {}

const systemConfigurationSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {},
})

export const plug = { [stateName]: systemConfigurationSlice.reducer }
export default systemConfigurationSlice.reducer
